import { Component, Input } from '@angular/core';

@Component({
  selector: 'clock-svg',
  templateUrl: './clock-svg.component.html',
  styleUrls: ['./../../svg.scss']
})
export class ClockSvgComponent {
  @Input() active:boolean=false;
  constructor() { }
}
